import { render } from "./FileCellType.vue?vue&type=template&id=0062f160"
import script from "./FileCellType.vue?vue&type=script&lang=js"
export * from "./FileCellType.vue?vue&type=script&lang=js"

import "./FileCellType.vue?vue&type=style&index=0&id=0062f160&lang=scss"

import exportComponent from "/Users/chenjun/Desktop/myProject/pbl-web/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__